import { getType, isFn, isNoE, isNoW, isNullOrEmpty } from '@/utils/obj-utils';
import { CaseType } from '@/types';
import utils from '@/utils/index';

export const formatString = (str: string, data: any, forceReplace = false) => {
  if (!str) return undefined;
  let result = str;
  const getKeyData = (key: string, data: Record<string, any>) => {
    const val = data[key];
    if (!val) return val;
    if (typeof val !== 'string') {
      return '' + val;
    }
    return val;
  };
  if (data) {
    result = str.replace(/##[a-z0-9_-]+##/gi, (match) => {
      const key = match.replace(/##/g, '');
      const val = getKeyData(key, data);
      return val ?? match;
    });
    result = result.replace(/{{1,2}[a-z0-9-_]+}{1,2}/gi, (match) => {
      const key = match.replace(/[{}]/g, '');
      const val = getKeyData(key, data);
      return val ?? match;
    });
  }
  return result;
};
export const eq = (a: any, b: any, ignoreCase = true, ignoreWhitespace = true) => {
  if (utils.obj.isNoE(a) || utils.obj.isNoE(b)) {
    return a === b;
  }
  const aType = getType(a),
    bType = getType(b);
  if (aType !== '[object String]' && isFn(a.toString)) a = a.toString();
  if (bType !== '[object String]' && isFn(b.toString)) b = b.toString();
  if (aType === '[object Number]') a = '' + a;
  if (bType === '[object Number]') b = '' + b;
  if (ignoreCase) {
    a = isFn(a?.toLowerCase) ? a.toLowerCase() : a;
    b = isFn(b?.toLowerCase) ? b.toLowerCase() : b;
  }
  if (ignoreWhitespace) {
    a = a.replace(/\s*/gi, '');
    b = b.replace(/\s*/gi, '');
  }
  return a === b;
};

export const randomString = (len: number, type: CaseType) => {
  const str = '0123456789abcdefghijklmnopqrstuvwxyz';
  const result: string[] = [];
  for (let i = 0; i < len; i++) {
    let char = str[Math.floor(Math.random() * str.length)];
    char =
      type === 'upperCase'
        ? char.toUpperCase()
        : type === 'lowerCase'
          ? char.toLowerCase()
          : Math.random() >= 0.5
            ? char.toUpperCase()
            : char.toLowerCase();
    result.push(char);
  }
  return result.join('');
};
export const toCase = (str?: string | null, type?: CaseType) => {
  if (isNoW(str) || !type) return str;
  switch (type) {
    case 'lowerCase':
      return str!.toLowerCase();
    case 'upperCase':
      return str!.toUpperCase();
    case 'Capitalize':
      return str!.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
    default:
      return str;
  }
};
export const toCapitalize = (str?: string | null) => {
  if (isNoW(str)) return str;
  return str!
    .split(' ')
    .map((word) => toFistLetterUpper(word))
    .join(' ');
};
export const toFistLetterUpper = (str?: string | null) => {
  if (isNoW(str)) return str;
  if (str!.length === 1) {
    return str!.toUpperCase();
  }
  return str![0].toUpperCase() + str!.substring(1, str!.length).toLowerCase();
};
export const toPascalCase = (str?: string | null) => {
  if (isNoW(str)) return str;
  return str!.replace(/(?:^|\s|-|_)\S/g, (a) => a.toUpperCase());
};
/**
 * @param {Array<String>} stringArray
 * @param {String} separator
 * @param {(str: String) => String} formatter
 * @returns {String}
 */
export const concatString = (stringArray: string[], separator = ', ', formatter?: Function) => {
  let result = '';
  for (let str of stringArray) {
    if (isNoW(str)) continue;
    if (formatter) {
      str = formatter(str);
    }
    if (result !== '') {
      result += separator;
    }
    result += str;
  }
  return result;
};
export const ifEmpty = (...strArray: any[]) => {
  return ifEmptyField(strArray);
};
export const ifEmptyField = (ObjArray: any[], valueFn?: (x: any) => boolean) => {
  for (const obj of ObjArray) {
    const objVal = valueFn ? valueFn(obj) : obj;
    if (isNoE(objVal)) continue;
    return obj;
  }
  return '';
};
